import { render, staticRenderFns } from "./printPage.vue?vue&type=template&id=20e20dd1&"
import script from "@viewJs/print/printPage.js?vue&type=script&lang=js&"
export * from "@viewJs/print/printPage.js?vue&type=script&lang=js&"
import style0 from "./printPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports